"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.allotmentInvoiceColumns = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const verify_1 = require("../../../utils/verify");
const DateTime_1 = require("../../DateTime");
const Payment_1 = require("../../Reservation/List/Payment");
const idColumn_1 = require("../../Table/columns/idColumn");
const actionsColumn_1 = require("./actionsColumn");
const Status_1 = require("./Cell/Status");
const allotmentInvoiceColumns = (config) => {
    var _a, _b, _c, _d, _e, _f, _g;
    return ([
        (0, idColumn_1.idColumn)({
            disableSortBy: true,
            hidden: (_a = config.id) === null || _a === void 0 ? void 0 : _a.hidden,
        }),
        {
            Header: () => (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Allotment/InvoiceList/Column:agent', defaultMessage: 'Agent' })),
            id: 'agent',
            Cell: ({ row }) => { var _a, _b; return (_b = (_a = (0, verify_1.verifyAgent)(row.original.agent)) === null || _a === void 0 ? void 0 : _a.displayName) !== null && _b !== void 0 ? _b : null; },
            hidden: (_b = config.agent) === null || _b === void 0 ? void 0 : _b.hidden,
        },
        {
            Header: () => (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Allotment/InvoiceList/Column:title', defaultMessage: 'Title' })),
            id: 'title',
            Cell: ({ row }) => row.original.title,
            canSort: false,
            hidden: (_c = config.title) === null || _c === void 0 ? void 0 : _c.hidden,
        },
        {
            Header: () => (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Allotment/InvoiceList/Column:invoiceDate', defaultMessage: 'Invoice Date' })),
            id: 'invoiceDate',
            Cell: ({ row }) => (react_1.default.createElement(DateTime_1.Date, { value: row.original.invoiceDate, isLocalTime: true })),
            canSort: true,
            hidden: (_d = config.invoiceDate) === null || _d === void 0 ? void 0 : _d.hidden,
        },
        {
            Header: () => (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Allotment/InvoiceList/Column:paymentDeadline', defaultMessage: 'Due Date' })),
            id: 'paymentDeadline',
            Cell: ({ row }) => (react_1.default.createElement(DateTime_1.Date, { value: row.original.paymentDeadline, isLocalTime: true })),
            hidden: (_e = config.paymentDeadline) === null || _e === void 0 ? void 0 : _e.hidden,
        },
        {
            Header: () => (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Allotment/InvoiceList/Column:payment', defaultMessage: 'Payment' })),
            id: 'payment',
            Cell: ({ row }) => (react_1.default.createElement(Payment_1.ListPaymentCell, { total: row.original.totalWithDiscount, totalPaid: row.original.totalPaid, payments: row.original.payments })),
            hidden: (_f = config.total) === null || _f === void 0 ? void 0 : _f.hidden,
        },
        {
            Header: () => (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Allotment/InvoiceList/Column:status', defaultMessage: 'Status' })),
            id: 'status',
            Cell: ({ row }) => react_1.default.createElement(Status_1.AllotmentInvoiceStatusCell, { status: row.original.status }),
            hidden: (_g = config.status) === null || _g === void 0 ? void 0 : _g.hidden,
        },
        (0, actionsColumn_1.allotmentInvoiceActionsColumn)(config.actions),
    ]);
};
exports.allotmentInvoiceColumns = allotmentInvoiceColumns;
//# sourceMappingURL=tableColumns.js.map